import request from "../../services/HTTPClient";
import { requestMethods, API } from "../../constants";

function normalizeExpenseResponse(response) {
  if (!response) {
    throw new Error("No response from server");
  }

  // Si la respuesta es un array simple
  if (Array.isArray(response)) {
    return { data: response };
  }

  // Si HTTPClient envolvió: { data: { message, summary, grand_total, data: [...], ... } }
  if (response.data && response.data.data && Array.isArray(response.data.data)) {
    // Devolver la estructura completa del API
    return response.data;
  }

  // Si es directamente la estructura del API: { message, summary, grand_total, data: [...], ... }
  if (response.data && Array.isArray(response.data)) {
    return response;
  }

  // Fallback
  return { data: [] };
}

function AddExpense(request_body) {
  return request({
    url: API.EXPENSES.CREATE,
    method: requestMethods.POST,
    data: {
      ...request_body,
    },
  });
}

function ListExpenses(filters = {}) {
  return request({
    url: API.EXPENSES.LIST,
    method: requestMethods.GET,
    params: filters,
  }).then(normalizeExpenseResponse);
}

function GetExpenseById(id) {
  return request({
    url: `${API.EXPENSES.GET_BY}${id}`,
    method: requestMethods.GET,
  });
}

function EditExpense(id, request_body) {
  return request({
    url: `${API.EXPENSES.EDIT}${id}`,
    method: requestMethods.PUT,
    data: {
      ...request_body,
    },
  });
}

function DeleteExpense(id) {
  return request({
    url: `${API.EXPENSES.DELETE}${id}`,
    method: requestMethods.DELETE,
  });
}

function GetExpensesByType(type, year, month) {
  return request({
    url: `${API.EXPENSES.LIST}/filter/by-type`,
    method: requestMethods.GET,
    params: {
      type,
      year,
      month,
    },
  }).then(normalizeExpenseResponse);
}

function GetExpenseSummaryByPeriod(year, month) {
  return request({
    url: `${API.EXPENSES.LIST}/summary/by-period`,
    method: requestMethods.GET,
    params: {
      year,
      month,
    },
  });
}

function GetExpensesByYear(year) {
  return request({
    url: `${API.EXPENSES.LIST}/year/${year}`,
    method: requestMethods.GET,
  });
}

function GetExpensesByMonth(year, month) {
  return request({
    url: `${API.EXPENSES.LIST}/year/${year}/month/${month}`,
    method: requestMethods.GET,
  });
}

const ExpensesService = {
  AddExpense,
  ListExpenses,
  GetExpenseById,
  GetExpensesByYear,
  GetExpensesByMonth,
  GetExpensesByType,
  GetExpenseSummaryByPeriod,
  EditExpense,
  DeleteExpense,
};

export default ExpensesService;
